export const NO_BACK_BUTTON_PATHS = [
  "/login",
  "/login/reset-password",
  "/shop-not-connected",
  "/shop-not-active",
  "/otp-trust",
  "/invitation-failure",
];
